
export const SET_SEARCH = 'SET_SEARCH';
export const SET_DATE = 'SET_DATE';
export const SET_TRAVELER = 'SET_TRAVELER';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';


export function setSearch(search) {
    return {
        type: SET_SEARCH,
        search
    };
}
export function setSearchDate(date) {
    return {
        type: SET_DATE,
        date
    };
}
export function setSearchTravelers(traveler) {
    return {
        type: SET_TRAVELER,
        traveler
    };
}
export function clearSearch() {
    return {
        type: CLEAR_SEARCH
    };
}
export function setBusSearch(search) {
    return {
        type: 'SET_BUS_SEARCH',
        search
    };
}



// WEBPACK FOOTER //
// ./src/redux/actions/search.js